export class ConfigType {
  public static readonly typeSuccess = 'SUCCESS'
  public static readonly typeError = 'ERROR'
  public static readonly typeWarning = 'WARNING'
}
